import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CasePermanentMedicationDecline from './CasePermanentMedicationDecline';

interface Props extends BaseModalProps {
	caseId: string;
	onSuccess: () => void;
}

const CasePermanentMedicationDeclineModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.casePermanentMedicationDecline.modalTitle'>
			<CasePermanentMedicationDecline
				caseId={props.caseId}
				onSuccess={props.onSuccess}
			/>
		</BaseModal>
	);
};

export default CasePermanentMedicationDeclineModal;
